import React from "react";

import omniscanLogo
from "../../../../images/omniscanlogo_dark.png";


import { useHistory } from "react-router-dom";


export default function EvaFooter()
{
    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------
	
	const history =
	        useHistory();

    return (

        <footer style={footerStyle} className="eva-footer">

            <div style={contentStyle} className="eva-footer-content">

                {/* Brand */}
                <div style={brandStyle}>

				<img
				    src={omniscanLogo}
				    alt="OmniScan Pro"
				    title="Return to OmniScan"
				    onClick={
				        () =>
				        {
				            history.push("/home");
				        }
				    }
				    style={logoStyle}
				/>

                    <div style={straplineStyle}>
                        Property Intelligence Hub
                    </div>

                </div>


                {/* Links */}
                <div style={linksStyle} className="eva-footer-links">

                    <span style={linkStyle}>
                        Privacy
                    </span>

                    <span style={linkStyle}>
                        Terms
                    </span>

                    <span style={linkStyle}>
                        Accessibility
                    </span>

                </div>

            </div>


            {/* Bottom */}
            <div style={bottomStyle} className="eva-footer-bottom">

                <div>

                    © {new Date().getFullYear()} OmniScan Pro Ltd.
                    All rights reserved.

                </div>

                <div style={evaStyle} className="eva-footer-eva">
                    EVA · Intelligent Estate Assistant
                </div>

            </div>

        </footer>

    );
}


//============================================================
// Styles
//============================================================

const footerStyle =
{
    width:
        "100%",

    padding:
        "38px 48px 22px 48px",

    boxSizing:
        "border-box",

    background:
        "linear-gradient(135deg,#17151d 0%,#0d0c11 100%)",

    color:
        "#ffffff"
};


const contentStyle =
{
    display:
        "flex",

    alignItems:
        "center",

    justifyContent:
        "space-between",

    paddingBottom:
        "28px",

    borderBottom:
        "1px solid rgba(255,255,255,0.10)"
};


const brandStyle =
{
    display:
        "flex",

    flexDirection:
        "column",

    alignItems:
        "flex-start",

    gap:
        "8px"
};


const logoStyle =
{
    width:
        "165px",

    height:
        "auto",

    display:
        "block",

    objectFit:
        "contain",
		
	cursor:
	    "pointer"
};


const straplineStyle =
{
    fontSize:
        "12px",

    color:
        "rgba(255,255,255,0.52)",

    letterSpacing:
        "0.2px"
};


const linksStyle =
{
    display:
        "flex",

    alignItems:
        "center",

    gap:
        "28px"
};


const linkStyle =
{
    fontSize:
        "12px",

    fontWeight:
        500,

    color:
        "rgba(255,255,255,0.68)",

    cursor:
        "pointer"
};


const bottomStyle =
{
    display:
        "flex",

    alignItems:
        "center",

    justifyContent:
        "space-between",

    paddingTop:
        "18px",

    fontSize:
        "11px",

    color:
        "rgba(255,255,255,0.38)"
};


const evaStyle =
{
    color:
        "rgba(255,255,255,0.52)",

    fontWeight:
        500
};